
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { Toaster } from 'sonner';

// Initialize app with error handling
const initializeApp = () => {
  try {
    const rootElement = document.getElementById('root');
    
    if (!rootElement) {
      console.error('Root element not found. Cannot mount React application.');
      return;
    }

    // Add this line to hide Lovable badge globally - with proper type safety
    if (typeof window !== 'undefined') {
      // Check if __LOVABLE__ exists first, then assign to it
      if (window.__LOVABLE__) {
        window.__LOVABLE__.hideBadge = true;
      } else {
        // Initialize it if it doesn't exist
        window.__LOVABLE__ = { hideBadge: true };
      }
    }

    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
        <Toaster position="top-right" richColors />
      </React.StrictMode>
    );
    
    console.log('React application successfully mounted.');
  } catch (error) {
    console.error('Failed to initialize React application:', error);
    // Display a user-friendly error message
    document.body.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: system-ui, sans-serif;">
        <h1 style="font-size: 24px; margin-bottom: 16px;">Application Error</h1>
        <p style="font-size: 16px; max-width: 500px; text-align: center; margin-bottom: 24px;">
          We're having trouble loading the application. Please try refreshing the page.
        </p>
        <button 
          style="padding: 8px 16px; background: #4f46e5; color: white; border: none; border-radius: 4px; cursor: pointer;"
          onclick="window.location.reload()"
        >
          Refresh Page
        </button>
      </div>
    `;
  }
};

// Start the application
initializeApp();
